export default __webpack_public_path__ + "static/media/furniture-store.4ea41ee9.png";